import TwoDrilldownTable from "../../../Components/Table/TwoDrilldownTable";

const Columns = [
  {
    id: "region",
    header: "Region",
    accessorFn: (value) => value.Region,
    cell: (info) => (
      <span
        className="text-center  w-20"
        title="Click to view Statewise Lead Source "
      >
        {info?.getValue()}
      </span>
    ),
    size: 200,
  },

  {
    header: "Beat Plan",
    accessorFn: (value) => value.BeatPlan,
    cell: ({ row }) => (
      <span className="text-right">{row?.original.BeatPlan}</span>
    ),
  },
  {
    header: "BTL",
    accessorFn: (value) => value.BTL,
    cell: ({ row }) => <span className="text-right">{row?.original.BTL}</span>,
  },
  {
    header: "Digital",
    accessorFn: (value) => value.Digital,
    cell: ({ row }) => (
      <span className="text-right ">{row?.original.Digital}</span>
    ),
  },
  {
    header: "ATL",
    accessorFn: (value) => value.ATL,
    cell: ({ row }) => <span className="text-right">{row?.original.ATL}</span>,
  },
  {
    header: "TGM",
    accessorFn: (value) => value.TGM,
    cell: ({ row }) => <span className="text-right">{row?.original.TGM}</span>,
  },
  {
    header: "Total ",
    accessorFn: (value) => value.Total,
    cell: ({ row }) => (
      <span className="text-right">{row?.original.Total}</span>
    ),
  },
];
const RtpTable = () => {
  const endpoint = "lead-source/";
  return (
    <div className="grid grid-cols-1 gap-3 lg:grid-cols-3">
      <TwoDrilldownTable
        QueryKey="retail_lead"
        heading="Region/Dealer Wise Retail"
        columns={Columns}
        endpoint={endpoint}
      />
      <TwoDrilldownTable
        QueryKey="pipeline_lead"
        heading=" Region/Dealer Wise Pipeline"
        columns={Columns}
        endpoint={endpoint}
        className="md:mt-0 mt-2"
      />
      <TwoDrilldownTable
        QueryKey="tqp_lead"
        heading="Region/Dealer Wise TQP"
        columns={Columns}
        endpoint={endpoint}
        className="md:mt-0 mt-2"
      />
    </div>
  );
};

export default RtpTable;
